<template>
  <svg
    id="Geral"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 236.237 213"
  >
    <g
      id="Retângulo_30"
      data-name="Retângulo 30"
      transform="translate(0 37)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_31"
      data-name="Retângulo 31"
      width="123"
      height="153"
      transform="translate(63 30)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-globe-americas"
      data-name="Icon awesome-globe-americas"
      d="M86.618.563a86.618,86.618,0,1,0,86.618,86.618A86.617,86.617,0,0,0,86.618.563Zm28.741,124.9c-1.362,1.355-2.791,2.777-3.95,3.94a8.346,8.346,0,0,0-2.155,3.741c-.527,1.977-.954,3.975-1.666,5.892L101.515,155.4a69.8,69.8,0,0,1-14.9,1.638v-9.563c.59-4.408-2.668-12.664-7.9-17.9a11.177,11.177,0,0,1-3.273-7.9v-11.18a11.14,11.14,0,0,0-5.749-9.769c-5.019-2.777-12.158-6.657-17.048-9.119A50.349,50.349,0,0,1,41.591,84l-.279-.251A40.094,40.094,0,0,1,35,76.507c-3.276-4.809-8.613-12.72-12.081-17.862A70.233,70.233,0,0,1,58.967,23.059l8.386,4.195a5.588,5.588,0,0,0,8.089-5V18.309a69.8,69.8,0,0,1,8.519-.845l9.884,9.884a5.588,5.588,0,0,1,0,7.9l-1.638,1.635L88.6,40.5a2.8,2.8,0,0,0,0,3.95l1.638,1.638a2.8,2.8,0,0,1,0,3.95L87.439,52.83a2.8,2.8,0,0,1-1.977.817h-3.14a2.792,2.792,0,0,0-1.949.793l-3.465,3.37a2.8,2.8,0,0,0-.552,3.252L81.8,71.956A2.8,2.8,0,0,1,79.3,76h-1.97a2.791,2.791,0,0,1-1.83-.685L72.263,72.5a5.594,5.594,0,0,0-5.431-1.083L55.946,75.047a4.175,4.175,0,0,0-.545,7.694l3.87,1.935a23.653,23.653,0,0,0,10.586,2.5c3.674,0,7.89,9.532,11.177,11.177h23.314a11.183,11.183,0,0,1,7.9,3.273l4.781,4.781a10.654,10.654,0,0,1,3.119,7.534,16.253,16.253,0,0,1-4.792,11.519Zm30.285-31.906a8.383,8.383,0,0,1-4.942-3.482l-6.28-9.42a8.372,8.372,0,0,1,0-9.3l6.842-10.261a8.373,8.373,0,0,1,3.227-2.847l4.533-2.267a67.667,67.667,0,0,1,6.811,40.12Z"
      transform="translate(63 -0.563)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
